import z from "zod";
import { TenancySchema } from "./tenancyTypes";
import { RolesByScopeSchema, ScopeKeySchema } from "./userContextTypes";

const OpSchema = z.enum(["op.read", "op.create", "op.update", "op.delete"]);

// capabilities[resource][scope] -> list of ops. Resource keys are free-form
// because the backend list grows. Per-scope entries are optional: the server
// only emits keys for scopes the resource declares in roles.json.
const CapabilitiesSchema = z.record(z.string(), z.record(ScopeKeySchema, z.array(OpSchema).optional()));

export const ContextResponseSchema = TenancySchema.extend({
  rolesByScope: RolesByScopeSchema,
  capabilities: CapabilitiesSchema,
});
export type ContextResponse = z.infer<typeof ContextResponseSchema>;
